module.exports = __webpack_public_path__ + "img/convex.93c318b5.svg";